import { Directive, ElementRef, Injector } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';
import { ScopeProvider } from '../../../upgraded.providers';

@Directive({
  selector: 'app-workers',
  providers: [ScopeProvider],
})
export class WorkersUpgradeDirective extends UpgradeComponent {
  constructor(elementRef: ElementRef, injector: Injector) {
    super('workersDirective', elementRef, injector);
  }
}
